import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'lib-alert-sticky',
  imports: [],
  templateUrl: './alert-sticky.component.html',
  styleUrl: './alert-sticky.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AlertStickyComponent {
  icon = input<string>();
  message = input<string>();
  inlineClasses = input<string>();
  style = input<Styles>('primary1');

  styles = {
    primary1: 'bg-primary-500 text-white',
    primary2: 'bg-primary-50 text-primary-700',
    neutral: 'bg-neutra-50 text-neutra-700',
    white: 'bg-white text-neutra-700',
  };

  protected isShownAlert = true;

  protected closeAlert() {
    this.isShownAlert = false;
  }
}

type Styles = 'primary1' | 'primary2' | 'neutral' | 'white';
